<template>
  <table class="lytable" :style="{ height: height + 'px' }">
    <thead ref="thead">
      <tr>
        <td
          :style="{
            width: x.width ? x.width + 'px' : '',
            minWidth: x.minWidth ? x.minWidth + 'px' : '',
            maxWidth: x.maxWidth ? x.maxWidth + 'px' : '',
          }"
          v-for="(x, index) in columns"
          :key="index"
        >
          <template v-if="x.title">{{ x.title }}</template>
          <template v-else>#</template>
        </td>
      </tr>
    </thead>
    <tbody ref="tbody">
      <tr
        v-for="(y, index1) in tableData"
        :key="index1"
        :class="{ red: y.color }"
        :id="y.row ? 'row' + y.row : 'row' + index1"
      >
        <td
          :style="{
            width: x.width ? x.width + 'px' : '',
            minWidth: x.minWidth ? x.minWidth + 'px' : '',
            maxWidth: x.maxWidth ? x.maxWidth + 'px' : '',
          }"
          :class="{ blue: x.color }"
          v-for="(x, index) in columns"
          :key="index"
        >
          <template v-if="x.type == 'index'">{{ index1 + 1 }}</template>
          <template v-if="x.key">{{ y[x.key] }}</template
          ><slot
            v-if="x.slot"
            :name="x.slot"
            :row="tableData[index1]"
            :index="index1"
          ></slot>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  props: ["data", "columns", "height"],
  data() {
    return {
      tableData: [],
    };
  },
  methods: {
    tongbu() {
      const thead = this.$refs.thead;
      const tbody = this.$refs.tbody;
      tbody.addEventListener("scroll", function (e) {
        thead.scrollLeft = tbody.scrollLeft;
      });
    },
    freshColor() {
      setTimeout(() => {
        var m = this.tableData;
        this.tableData = [];
        setTimeout(() => {
          this.tableData = m;
        }, 300);
      }, 200);
    },
    scroll(id) {
      const tbody = this.$refs.tbody;
      var a = document.getElementById("row" + id).offsetTop;
      console.log(document.getElementById("row" + id));
      //tbody.scrollTop = a - 50;
      tbody.scrollTo({
        top: a-50,
        behavior: "smooth",
      });
    },
    scrollLeft(id) {
      const tbody = this.$refs.tbody;

      //tbody.scrollTop = a - 50;
      tbody.scrollTo({
        left: 500,
        behavior: "smooth",
      });
    },
  },
  watch: {
    data(v) {
      this.tableData = v;
    },
  },
  mounted() {
    this.tongbu();
    this.tableData = this.data;
  },
};
</script>
<style>
.lytable {
  padding: 0px;
  height: calc(100% - 20px);
  margin-bottom: 20px;
  width: 100%;
  display: block;
}
.lytable tr {
  width: 100%;
}
.lytable th {
  line-height: 3;
}

.lytable td {
  padding: 2px 4px;
  text-align: left;
  width: 100px;
  border: none;
}
.lytable td.blue {
  background: #d5d5f8;
  color: #32228e;
}
.lytable thead {
  background: #ececec;
  width: calc(100% - 1em);
}
.lytable thead tr,
.lytable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.lytable tbody tr.red {
  background: #ffdada;
  color: #aa1212;
}

.lytable tbody {
  display: block;
  width: 100%;
  height: calc(100% - 32px);
  overflow-x: scroll;
  overflow-y: scroll;
  padding-top: 10px;
}
.lytable thead {
  display: block;
  width: 100%;
  overflow-x: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/lytable.vue